import { FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";
import { useState } from "react";
import Textarea from "@components/new/Textarea/Textarea";
import Button from "@components/new/Button/Button";
import {
    SSB_BUILD_MY_STRATEGY,
    SSB_GET_STARTED_FORM_PLACEHOLDER,
    SSB_GET_STARTED_FORM_SUBTITLE,
    SSB_GET_STARTED_FORM_TITLE,
    SSB_INPUT_LIMIT_MESSAGE,
    SSB_INPUT_MAX_LENGTH,
} from "../Strategy.constants";
import "./StrategyGetStartedForm.styles.scss";

interface Props {
    initialValue?: string | null;
    onSubmit: (value: string | null) => void;
    isSubmitting?: boolean;
}

const StrategyGetStartedForm: FCX<Props> = ({ className, initialValue, onSubmit, isSubmitting }) => {
    const [description, setDescription] = useState(initialValue ?? "");
    const isAtLimit = description.length >= SSB_INPUT_MAX_LENGTH;

    return (
        <div className={cn("StrategyGetStartedForm", className)}>
            <p className="StrategyGetStartedForm__title">{SSB_GET_STARTED_FORM_TITLE}</p>
            <p className="StrategyGetStartedForm__subtitle">{SSB_GET_STARTED_FORM_SUBTITLE}</p>
            <Textarea
                value={description}
                onChange={value => setDescription(value.slice(0, SSB_INPUT_MAX_LENGTH))}
                placeholder={SSB_GET_STARTED_FORM_PLACEHOLDER}
                minHeight={67}
                maxHeight={67}
                hasError={isAtLimit}
            />
            {isAtLimit && <p className="StrategyGetStartedForm__validation">{SSB_INPUT_LIMIT_MESSAGE}</p>}
            <div className="StrategyGetStartedForm__submit">
                <Button
                    modifiers={["primary"]}
                    onClick={() => onSubmit(description.trim() || null)}
                    isLoading={isSubmitting}
                    isDisabled={isSubmitting}
                >
                    {SSB_BUILD_MY_STRATEGY}
                </Button>
            </div>
        </div>
    );
};

export default StrategyGetStartedForm;
